__turbopack_context__.v({
  "icon": "_8u7mqa_icon",
  "loader": "_8u7mqa_loader",
  "root": "_8u7mqa_root",
});
